export const mockShipments = {
  success: true,
  message: null,
  errorCode: null,
  item: {
    shipments: [
      {
        shipmentId: 1001,
        probill: "168136661",
        billTo: {
          id: 1,
          accountNumber: "ACC001",
          accountName: "ACME Corporation",
          address: "1234 Metal Way",
          city: "New York",
          state: "NY",
          postalCode: "10199",
          contactName: "Jason Miller",
          phone: "555-0100",
          email: "jason.miller@acme.com",
        },
        shipper: {
          id: 2,
          accountNumber: "SHP001",
          accountName: "Nat Stuff TDS0182",
          address: "456 Ship Ave",
          city: "Chicago",
          state: "IL",
          postalCode: "60601",
          contactName: "Maria Garcia",
          phone: "555-0200",
          email: "maria@natstuff.com",
        },
        consignee: {
          id: 3,
          accountNumber: "CNS001",
          accountName: "Dylt-lax AB1234",
          address: "789 Receive Rd",
          city: "Los Angeles",
          state: "CA",
          postalCode: "90011",
          contactName: "Bob Johnson",
          phone: "555-0300",
          email: "bob@dyltlax.com",
        },
        pallets: 1,
        pieces: 7,
        weight: 500,
        tags: ["LM", "APTR", "HM", "TL"],
        status: "REQUESTED",
        pickupTime: "08/19/2025 12:00 PM",
        deliveredTime: "08/21/2025 02:30 PM",
        currentLocation: "New York, NY 10199",
      },
      {
        shipmentId: 1002,
        probill: "168136662",
        billTo: {
          id: 4,
          accountNumber: "ACC002",
          accountName: "TechCorp Industries",
          address: "5678 Industrial Blvd",
          city: "Chicago",
          state: "IL",
          postalCode: "60601",
          contactName: "Sarah Johnson",
          phone: "555-0400",
          email: "sarah@techcorp.com",
        },
        shipper: {
          id: 5,
          accountNumber: "SHP002",
          accountName: "TechCorp Manufacturing",
          address: "100 Factory Lane",
          city: "Detroit",
          state: "MI",
          postalCode: "48201",
          contactName: "Mike Stevens",
          phone: "555-0500",
          email: "mike@techcorpmfg.com",
        },
        consignee: {
          id: 6,
          accountNumber: "CNS002",
          accountName: "Global Logistics Hub",
          address: "200 Port Dr",
          city: "Miami",
          state: "FL",
          postalCode: "33101",
          contactName: "Lisa Chen",
          phone: "555-0600",
          email: "lisa@globallog.com",
        },
        pallets: 3,
        pieces: 15,
        weight: 1200,
        tags: ["LM", "APTR"],
        status: "IN TRANSIT",
        pickupTime: "08/18/2025 08:00 AM",
        deliveredTime: "08/22/2025 10:35 AM",
        currentLocation: "Atlanta, GA 30301",
      },
      {
        shipmentId: 1003,
        probill: "168136663",
        billTo: {
          id: 7,
          accountNumber: "ACC003",
          accountName: "AutoParts Enterprises",
          address: "9999 Commerce Street",
          city: "Houston",
          state: "TX",
          postalCode: "77002",
          contactName: "Michael Chen",
          phone: "555-0700",
          email: "mchen@autoparts.com",
        },
        shipper: {
          id: 8,
          accountNumber: "SHP003",
          accountName: "AutoParts Central",
          address: "1500 Parts Way",
          city: "Dallas",
          state: "TX",
          postalCode: "75201",
          contactName: "Tom Rodriguez",
          phone: "555-0800",
          email: "tom@autocentral.com",
        },
        consignee: {
          id: 9,
          accountNumber: "CNS003",
          accountName: "West Coast Distribution",
          address: "3000 Warehouse Pkwy",
          city: "Seattle",
          state: "WA",
          postalCode: "98101",
          contactName: "Emma Wilson",
          phone: "555-0900",
          email: "emma@wcdist.com",
        },
        pallets: 5,
        pieces: 25,
        weight: 2000,
        tags: ["HM", "TL"],
        status: "REQUESTED",
        pickupTime: "08/20/2025 10:35 AM",
        deliveredTime: "08/22/2025 04:00 PM",
        currentLocation: "Dallas, TX 75201",
      },
      {
        shipmentId: 1004,
        probill: "168136664",
        billTo: {
          id: 10,
          accountNumber: "ACC004",
          accountName: "Southwest Freight Solutions",
          address: "4567 Warehouse Row",
          city: "Phoenix",
          state: "AZ",
          postalCode: "85001",
          contactName: "Emily Rodriguez",
          phone: "555-1000",
          email: "emily@swfreight.com",
        },
        shipper: {
          id: 11,
          accountNumber: "SHP004",
          accountName: "Southwest Freight Co",
          address: "800 Logistics Blvd",
          city: "San Antonio",
          state: "TX",
          postalCode: "78201",
          contactName: "Carlos Martinez",
          phone: "555-1100",
          email: "carlos@swfreightco.com",
        },
        consignee: {
          id: 12,
          accountNumber: "CNS004",
          accountName: "Desert Logistics Center",
          address: "500 Strip Blvd",
          city: "Las Vegas",
          state: "NV",
          postalCode: "89101",
          contactName: "Amanda White",
          phone: "555-1200",
          email: "amanda@desertlog.com",
        },
        pallets: 2,
        pieces: 12,
        weight: 800,
        tags: ["UC", "APTR"],
        status: "DELIVERED",
        pickupTime: "08/17/2025 12:00 PM",
        deliveredTime: "08/19/2025 12:00 PM",
        currentLocation: "Las Vegas, NV 89101",
      },
      {
        shipmentId: 1005,
        probill: "168136665",
        billTo: {
          id: 13,
          accountNumber: "ACC005",
          accountName: "Mountain Freight Services",
          address: "1234 Business Park",
          city: "Denver",
          state: "CO",
          postalCode: "80201",
          contactName: "David Thompson",
          phone: "555-1300",
          email: "dthompson@mountainfreight.com",
        },
        shipper: {
          id: 14,
          accountNumber: "SHP005",
          accountName: "Mountain Freight Lines",
          address: "600 Alpine Dr",
          city: "Salt Lake City",
          state: "UT",
          postalCode: "84101",
          contactName: "Jennifer Lee",
          phone: "555-1400",
          email: "jlee@mountainlines.com",
        },
        consignee: {
          id: 15,
          accountNumber: "CNS005",
          accountName: "Pacific Coast Terminal",
          address: "700 Harbor Way",
          city: "Portland",
          state: "OR",
          postalCode: "97201",
          contactName: "Ryan Cooper",
          phone: "555-1500",
          email: "rcooper@paccoast.com",
        },
        pallets: 4,
        pieces: 20,
        weight: 1500,
        tags: ["LM", "TL"],
        status: "REQUESTED",
        pickupTime: "08/21/2025 12:00 PM",
        deliveredTime: "08/23/2025 09:15 AM",
        currentLocation: "Denver, CO 80201",
      },
      {
        shipmentId: 1006,
        probill: "168136666",
        billTo: {
          id: 16,
          accountNumber: "ACC006",
          accountName: "Northeast Supply Chain LLC",
          address: "7890 Distribution Way",
          city: "Boston",
          state: "MA",
          postalCode: "02101",
          contactName: "Amanda White",
          phone: "555-1600",
          email: "awhite@nesupply.com",
        },
        shipper: {
          id: 17,
          accountNumber: "SHP006",
          accountName: "Northeast Supply Chain",
          address: "400 Liberty Ave",
          city: "Philadelphia",
          state: "PA",
          postalCode: "19101",
          contactName: "Kevin Brown",
          phone: "555-1700",
          email: "kbrown@nesupplychain.com",
        },
        consignee: {
          id: 18,
          accountNumber: "CNS006",
          accountName: "Atlantic Warehouse",
          address: "900 Port Rd",
          city: "Providence",
          state: "RI",
          postalCode: "02901",
          contactName: "Rachel Green",
          phone: "555-1800",
          email: "rgreen@atlanticwh.com",
        },
        pallets: 1,
        pieces: 2,
        weight: 500,
        tags: ["UC", "APTR", "HM"],
        status: "DELIVERED",
        pickupTime: "08/16/2025 12:00 PM",
        deliveredTime: "08/19/2025 12:00 PM",
        currentLocation: "Providence, RI 02901",
      },
      {
        shipmentId: 1007,
        probill: "168136667",
        billTo: {
          id: 19,
          accountNumber: "ACC007",
          accountName: "Southern Transport Group",
          address: "3456 Logistics Lane",
          city: "Atlanta",
          state: "GA",
          postalCode: "30301",
          contactName: "Robert Martinez",
          phone: "555-1900",
          email: "rmartinez@sotransport.com",
        },
        shipper: {
          id: 20,
          accountNumber: "SHP007",
          accountName: "Southern Transport LLC",
          address: "1000 Music Row",
          city: "Nashville",
          state: "TN",
          postalCode: "37201",
          contactName: "Jessica Taylor",
          phone: "555-2000",
          email: "jtaylor@sotransportllc.com",
        },
        consignee: {
          id: 21,
          accountNumber: "CNS007",
          accountName: "Coastal Distribution",
          address: "800 Harbor Blvd",
          city: "Charleston",
          state: "SC",
          postalCode: "29401",
          contactName: "Daniel Kim",
          phone: "555-2100",
          email: "dkim@coastaldist.com",
        },
        pallets: 1,
        pieces: 2,
        weight: 500,
        tags: ["UC", "TL"],
        status: "DELIVERED",
        pickupTime: "08/15/2025 12:00 PM",
        deliveredTime: "08/19/2025 12:00 PM",
        currentLocation: "Charleston, SC 29401",
      },
      {
        shipmentId: 1008,
        probill: "168136668",
        billTo: {
          id: 22,
          accountNumber: "ACC008",
          accountName: "Midwest Logistics Inc",
          address: "2200 Industrial Way",
          city: "Minneapolis",
          state: "MN",
          postalCode: "55401",
          contactName: "Patricia Anderson",
          phone: "555-2200",
          email: "panderson@midwestlog.com",
        },
        shipper: {
          id: 23,
          accountNumber: "SHP008",
          accountName: "Midwest Distribution",
          address: "3300 Commerce Dr",
          city: "Milwaukee",
          state: "WI",
          postalCode: "53201",
          contactName: "Steven Harris",
          phone: "555-2300",
          email: "sharris@midwestdist.com",
        },
        consignee: {
          id: 24,
          accountNumber: "CNS008",
          accountName: "Central Warehouse Co",
          address: "4400 Freight Blvd",
          city: "Kansas City",
          state: "MO",
          postalCode: "64101",
          contactName: "Nancy Clark",
          phone: "555-2400",
          email: "nclark@centralwh.com",
        },
        pallets: 6,
        pieces: 30,
        weight: 2500,
        tags: ["LM", "APTR", "HM", "TL"],
        status: "IN TRANSIT",
        pickupTime: "08/19/2025 07:00 AM",
        deliveredTime: "08/23/2025 03:00 PM",
        currentLocation: "Chicago, IL 60601",
      },
      {
        shipmentId: 1009,
        probill: "168136669",
        billTo: {
          id: 25,
          accountNumber: "ACC009",
          accountName: "Pacific Northwest Freight",
          address: "5500 Terminal Ave",
          city: "Tacoma",
          state: "WA",
          postalCode: "98401",
          contactName: "Christopher Lewis",
          phone: "555-2500",
          email: "clewis@pnwfreight.com",
        },
        shipper: {
          id: 26,
          accountNumber: "SHP009",
          accountName: "Pacific Shipping Co",
          address: "6600 Dock St",
          city: "Oakland",
          state: "CA",
          postalCode: "94601",
          contactName: "Michelle Young",
          phone: "555-2600",
          email: "myoung@pacship.com",
        },
        consignee: {
          id: 27,
          accountNumber: "CNS009",
          accountName: "Northern Distribution Hub",
          address: "7700 Logistics Pkwy",
          city: "Spokane",
          state: "WA",
          postalCode: "99201",
          contactName: "Andrew Walker",
          phone: "555-2700",
          email: "awalker@northdist.com",
        },
        pallets: 8,
        pieces: 40,
        weight: 3200,
        tags: ["LM", "HM", "TL"],
        status: "REQUESTED",
        pickupTime: "08/22/2025 06:00 AM",
        deliveredTime: "08/25/2025 11:00 AM",
        currentLocation: "Oakland, CA 94601",
      },
      {
        shipmentId: 1010,
        probill: "168136670",
        billTo: {
          id: 28,
          accountNumber: "ACC010",
          accountName: "Gulf Coast Logistics",
          address: "8800 Port Access Rd",
          city: "New Orleans",
          state: "LA",
          postalCode: "70112",
          contactName: "Barbara Hall",
          phone: "555-2800",
          email: "bhall@gulfcoastlog.com",
        },
        shipper: {
          id: 29,
          accountNumber: "SHP010",
          accountName: "Gulf Transport Services",
          address: "9900 Shipping Ln",
          city: "Baton Rouge",
          state: "LA",
          postalCode: "70801",
          contactName: "Joseph Allen",
          phone: "555-2900",
          email: "jallen@gulftransport.com",
        },
        consignee: {
          id: 30,
          accountNumber: "CNS010",
          accountName: "Southern Freight Terminal",
          address: "1100 Distribution Dr",
          city: "Mobile",
          state: "AL",
          postalCode: "36601",
          contactName: "Elizabeth King",
          phone: "555-3000",
          email: "eking@sofreight.com",
        },
        pallets: 3,
        pieces: 18,
        weight: 1400,
        tags: ["UC", "APTR", "TL"],
        status: "DELIVERED",
        pickupTime: "08/14/2025 09:00 AM",
        deliveredTime: "08/18/2025 02:30 PM",
        currentLocation: "Mobile, AL 36601",
      },
    ],
    statusCounts: {
      totalShipments: 100,
      requested: 40,
      inTransit: 25,
      delivered: 35,
    },
    pagination: {
      totalRecords: 100,
      totalPages: 10,
      currentPage: 1,
      pageSize: 10,
    },
  },
};

export const mockShipmentsStatusCounts = {
  totalShipments: 100,
  requested: 40,
  inTransit: 25,
  delivered: 35,
};
